export const Data = [
  {
    id: 1,
    title: "Rosemary Chen - Senior Software Engineer",
    description: `Kobi is not afraid dive in and get his hands dirty even if he’s not familiar with the task. He isn’t afraid to ask questions no matter big or small, knows when to ask for help, and always has a can-do attitude.`,
  },
  {
    id: 2,
    title: "Chris Connelley - Senior Engineering Manager",
    description: `During his time on my team at Bill, Kobi was promoted from an associate software engineer to a full software engineer. His growth mindset allowed him to flourish in the particularly challenging environment of an acquired startup. Always up to the task, Kobi was quick to learn any new technology needed for the work such as the latest versions of React and Typescript as well as new rapidly changing in-house web component libraries. Kobi used his excellent interpersonal and communication skills to engage fully with his squad and contribute toward squad and department goals, quick to ask questions and offer assistance if he could help others.`,
  },
  {
    id: 3,
    title: "Rohit Menon - Project Manager",
    description:
      "I worked with Kobi on a couple of key projects at BILL. As someone who started out as a junior engineer on the team I have been impressed by his desire to learn and his career growth. Moreover, he is always open to new challenges and was a very productive engineer. Kobi would make a great addition to any team looking for front-end horsepower.",
  },
  {
    id: 4,
    title: "Leah Hullinger",
    description:
      "Jakobi started as an intern on my team. After only a few days I knew I wanted to extend him a full time position. I was impressed by how quickly he started asking questions, volunteering to own tasks, and asking for help when he was blocked. New developers often struggle in these areas at first, but not Kobi. From day one he's been a contributing member and asset to the team.",
  },
  {
    id: 5,
    title: "Dalton Miller - Software Engineer II",
    description:
      "Working with Kobi has been an absolute pleasure. His dedication and accountability are off the charts, making him an incredibly valuable asset to any team. Kobi is the go-to person for getting things done – he's always willing to take on any task and help out wherever he's needed. Any team would be lucky to have him as an Engineer, and I look forward to working with him again.",
  },
  {
    id: 6,
    title: "Tom Hester - Software Engineer",
    description:
      "Kobi Matagi consistently impresses with his unquenchable eagerness to learn and grow. No matter the challenge, he demonstrates a remarkable willingness to dive in and contribute, showcasing an exceptional ability to think critically and solve problems effectively. Kobi is a true asset to any team, bringing both skill and a positive, can-do attitude.",
  },
  {
    id: 7,
    title: "Mikhail Vnukov - Staff Software Engineer",
    description:
      "Having Kobi on the team has been a fantastic experience. He consistently goes above and beyond, dedicating himself fully to every task. Largely due to Kobi's unwavering commitment, we've been able to deliver our projects on time, even under challenging circumstances.",
  },
];
